export default {
  angentManage: {
    chargePlan: 'Pricing Plan',
    organizationTag: 'Organization Tag',
    textje8x: 'File Name',
    textd6a5: 'File Size',
    fileStatus: 'File Status',
    operator: 'Performed By',
    operationTime: 'Action Time',
    remark: 'Notes',
    confirmDeleteExportFile: 'Delete file "{fileName}"?',
    auto_108_00bbd0a1: 'Add School',
    auto_109_323176e9: 'Bulk Assign Learning Centers',
    auto_110_0aba07e4: 'Edit',
    auto_111_3974910f: 'Link Learning Center',
    auto_112_267ce3c2: 'Remove',
    auto_113_d0221b28: 'Notice',
    auto_114_3968fa67: 'Are you sure you want to remove?',
    auto_115_84ac5284: 'School Name',
    auto_116_60fb16eb: 'Enter School Name',
    auto_117_0a6559c0: 'School Location (City, State)',
    auto_118_184bc002: 'Grade Levels',
    auto_119_a311294f: 'Select Grade Levels',
    auto_120_f64f7d06: 'School Type',
    auto_121_cc0135ad: 'Select School Type',
    auto_122_917d1b7f: 'Boarding Status',
    auto_125_9a2afdd5: 'Select Learning Center',
    auto_126_bc008c75: 'Actions',
    auto_130_e9c403b6: 'School Address',
    auto_131_d0c268a5: 'Enter School Address',
    auto_133_880878f8: 'Select Boarding Status',
    auto_137_c5f37b51: 'Select School Type',
    auto_138_7b608045: 'Student Enrollment',
    auto_139_7ac46c85: 'Enter Student Enrollment',
    auto_140_bb775e75: 'Number of Classes',
    auto_141_ac4379b9: 'Enter Number of Classes',
    auto_142_5dba9534: 'School Overview',
    auto_143_c75e0f9e: 'Enter up to 1000 characters',
    auto_144_5501bd34: 'Notes',
    auto_145_4ab32238: 'Enter up to 500 characters',
    auto_147_48b76f6a: 'Select Learning Center',
    auto_414_b30f89a0: 'Clear Filters',
    auto_419_d52d4a56: 'Full Address',
    auto_430_72b510b7: 'Edit School',
    auto_1_5dbea729: 'Add New',
    auto_6_2ad7d5e1: 'All Learning Centers',
    auto_7_6b74106c: 'Selected Learning Centers',
    auto_10_acbcbf89: 'Ad Placement',
    auto_11_4b1e5ce3: 'Select Ad Placement',
    auto_12_98bf012e: 'Ad Name',
    auto_12_d7bddb28: 'Add Ad',
    auto_13_8a858b9d: 'State, City',
    auto_13_a12733c2: 'Enter Ad Name',
    auto_14_0232da13: 'Billing Status',
    auto_14_6f6fd7f3: 'Sort Order',
    auto_15_0e39805e: 'Please set the sort order',
    auto_15_9197175c: 'Learning Center Type',
    auto_16_dcebb3c9: 'Learning Center Category',
    auto_17_02f830c2: 'Custom',
    auto_17_796dbe36: 'Ad Image',
    auto_18_58acb097: 'Status',
    auto_19_8eda55dc: 'Display Scope',
    auto_20_17eb1ec8: 'Select',
    auto_22_0bd22920: 'Enter',
    auto_22_33a639ad: 'Last Edited Time',
    auto_23_d183ba8a: 'Enter Redirect URL',
    auto_24_3c3ec2fc: 'Route',
    auto_24_6b417098: 'Free',
    auto_25_5cad1762: 'Paid',
    auto_25_d6b4aa30: 'Enter Route',
    auto_26_92c26f06: 'Select Billing Status',
    auto_26_bd20cad5: 'Preview',
    auto_27_a09266aa: 'Select Learning Center Type',
    auto_28_c22fd1e2: 'Select Learning Center Category',
    auto_30_a46e8acd: 'Edit Ad',
    auto_31_37a929ba: 'Please select location first',
    auto_152_559ac074: 'Contract Type',
    auto_153_fd464748: 'Contract Name',
    auto_154_67dd4068: 'Contract ID',
    auto_155_9160b8a0: 'Contract Amount',
    auto_156_42436328: 'Contract Signing Date',
    auto_157_0cc00bfe: 'Contract Start Date',
    auto_158_298b8db7: 'Contract End Date',
    auto_158_abbed0fc: 'Add Contract',
    auto_159_3fbde64c: 'Monthly Recognized Revenue',
    auto_160_33a7227b: 'Contract Manager',
    auto_160_bc9ed7a4: 'Upload Attachment',
    auto_161_3b87923a: 'Add Agreement',
    auto_162_4859590f: 'Created Time',
    auto_163_6f4e4ad4: 'Created By',
    auto_164_5848197c: 'Last Updated Time',
    auto_165_65f8c2d4: 'Last Updated By',
    auto_166_6234ffac: 'File Type',
    auto_167_5bdbf60b: 'File Purpose',
    auto_168_eb0b3a22: 'Signing Date',
    auto_169_6534851f: 'Signing Manager',
    auto_179_fed75aa1: 'Contract updated successfully',
    auto_180_f808e435: 'Contract created successfully',
    auto_181_8f0bfc96: 'Failed to update contract',
    auto_182_df277363: 'Failed to create contract',
    auto_183_09754d66: 'Agreement updated successfully',
    auto_184_62c1fcf6: 'Agreement created successfully',
    auto_185_8997f4d1: 'Failed to update agreement',
    auto_186_aae610db: 'Failed to create agreement',
    auto_193_0fd9f522: 'Contract deleted successfully',
    auto_194_a280b383: 'Failed to delete contract',
    auto_195_ed654bde: 'Agreement deleted successfully',
    auto_196_a5439fb9: 'Failed to delete agreement',
    auto_199_b9cd767c: 'After unassigning the course, the Learning Center will no longer be able to assign it to students',
    auto_368_48455d5e: 'Enter course name',
    auto_370_5f25d5c2: 'Select subject',
    auto_376_16365df4: 'Select curriculum version',
    auto_378_fd39ec5e: 'Select curriculum type',
    auto_381_260a1818: 'Assignment Time',
    auto_388_f12f16c2: 'Assigned By',
    auto_49_d25b5fc6: 'Pricing and System Information',
    auto_53_f1d254ce: 'Enable Small Group Classes',
    auto_54_0d07eafa: '$ per session',
    auto_60_fa9e90c1: 'Enable Large Group Classes',
    auto_64_68f3e04f: 'Based on Learning Center pricing by grade level and pricing coefficient, the actual payment for elementary level is',
    auto_65_c32bba3f: '$5 per session',
    auto_67_91be6ec6: '$6 per session',
    auto_69_9e03b0e6: '$7 per session',
    auto_70_2d60ea96: 'During the fee waiver period, the actual payment for all levels is',
    auto_71_c2b1eff9: '$0 per session',
    auto_77_33db3040: 'Verification',
    auto_78_4c22b5f8: 'Updating pricing and system information requires verification. Send verification code now?',
    auto_197_2627d43c: 'Enter verification code',
    auto_198_3b1d3eb7: 'Verification code sent successfully',
    auto_199_3b783b70: 'Failed to send verification code',
    auto_201_4c816e56: 'Enter auto recharge deduction ratio',
    auto_202_1c3a2e51: 'Please update before saving',
    auto_203_ad9868b4: 'Pricing and system information saved successfully',
    auto_204_6e97e4df: 'Failed to save pricing and system information',
    auto_600166_6a425931: 'Actual payment (Middle School)',
    auto_700168_6e3832b8: 'Actual payment (High School)',
    auto_165_94efbea8: 'Add Initial Balance',
    auto_167_57991ebf: 'Gold Account',
    auto_205_adf76b23: 'Recharge Account',
    auto_206_f38cead2: 'Initial Balance',
    auto_207_f548cc9c: 'Payment Time',
    auto_208_f4e6d4be: 'Payment Method',
    auto_209_237fa570: 'Transaction ID',
    auto_213_4b8d40e9: 'Last Updated By',
    auto_214_19608d29: 'Last Updated Time',
    auto_216_01d50fd3: 'Zero Tens',
    auto_218_1b66f4e7: 'Zero Hundreds',
    auto_220_a79d6f7c: 'Zero Thousands',
    auto_222_0cbd246b: 'Zero Ten-Thousands',
    auto_224_58f35c2d: 'Triple Zero',
    auto_226_4098fa8c: 'Double Zero',
    auto_228_a30639f0: 'Zero Dollars',
    auto_232_24b2d4a9: 'Edit Master Franchisee Initial Balance',
    auto_233_7434df88: 'Saved successfully',
    auto_234_c284074b: 'Continue?',
    auto_236_0af6f5bb: 'Save failed',
    auto_238_72f71c15: 'Delete Master Franchisee Initial Balance',
    auto_27_ef3ce910: 'Account Information',
    auto_28_b5eb70e1: 'Add Account',
    auto_29_79eb76fb: 'Reset Password',
    auto_30_1962cee5: 'Copy Invitation',
    auto_31_fa023517: 'Disable Account',
    auto_32_f00f9205: 'Reactivate Account ',
    auto_33_b47d9a4f: 'Set as Standard Account',
    auto_34_62374bc9: 'Send SMS',
    auto_35_0f2e8708: 'Visit agents.squirrelai.com. Please reset your password after your first login.',
    auto_36_76937eb2: 'The account will be activated automatically after the invitation is accepted',
    auto_37_7488bdd5: 'After setting as a standard account, it can no longer be managed from the Master Franchisee profile',
    auto_38_4eb38d0f: 'The primary account under this ID can still manage this account through the Master Franchisee / Franchisee system',
    auto_49_d4dacb31: 'Send Invitation SMS',
    auto_50_59c5a166: 'Resend Invitation',
    auto_51_b2642af0: 'Invitation sent successfully',
    auto_52_1f6a60ae: 'Invitation failed',
    auto_53_67fdf4be: 'Copied successfully',
    auto_54_3fe737f2: 'Account disabled successfully',
    auto_55_d5ce9126: 'Failed to disable account',
    auto_56_5fde9fe9: 'Account enabled successfully',
    auto_57_37d1f6d9: 'Failed to enable account',
    auto_59_bff29c3c: 'Updated successfully',
    auto_60_400460b0: 'Update failed',
    auto_61_7684c8f7: 'Account updated successfully',
    auto_62_7140b72f: 'Failed to update account',
    auto_64_27ef51b4: 'Account created successfully',
    auto_65_bd54cc4e: 'Failed to create account',
    auto_66_9c97237c: 'SMS sent successfully',
    auto_93_6a436830: 'Learning Center Profile',
    auto_96_ed64406c: 'Pricing and System',
    auto_99_aed51598: 'Large Group Classes',
    auto_100_04cd98c2: 'Small Group Classes',
    auto_101_a22a83ec: 'Basic Information',
    auto_102_d0f0f776: 'IP Address',
    auto_103_b6d110da: 'Device Information',
    auto_104_ad632e46: 'Collapse',
    auto_105_ef54ff00: 'Expand',
    auto_400_4139981b: 'Edit Learning Center',
    auto_401_85ef36f0: 'Pending Confirmation',
    auto_402_40941d70: 'Linked',
    auto_403_a698454c: 'Not Linked',
    auto_408_14fc3601: 'Official Partner Learning Center',
    auto_409_afd388ce: 'Adaptive Learning Center (Los Angeles, CA)',
    auto_81_fd6ec8e0: 'Organization ID:',
    auto_82_33a82215: 'Expand',
    auto_83_d4dbf580: 'Collapse',
    auto_84_384732d9: 'Annual Rent',
    auto_85_8e060283: 'Monthly Rent',
    auto_86_c15acb83: 'IP Address',
    auto_87_3d415ccd: 'Account Name / Entity Name',
    auto_88_51d772a9: 'ID Card Scanner',
    auto_89_5904a7f9: 'Headquarters Lead Campaign',
    auto_90_741a9603: 'Daily Claim Limit',
    auto_91_7f527a0c: 'Daily Phone View Limit',
    auto_249_3c59bc76: 'Formal Handover',
    auto_250_f8314491: 'Pre-Handover',
    auto_258_0d75af8b: 'Enable',
    auto_259_2cd21d0c: 'Disable',
    auto_260_6e13beb2: 'Participate',
    auto_261_27fd171d: 'Do Not Participate',
    auto_262_2206ea1f: 'Resources',
    auto_126_a81a7420: 'Upload Business License',
    auto_127_f7c3dcc9: 'Select Location',
    auto_128_c311c9f7: 'Select Contract Manager',
    auto_129_11b39a48: 'Select Sales Representative',
    auto_130_b94d4abc: 'Learning Center',
    auto_131_e260471b: 'Contracting Entity Type',
    auto_132_bcf7c0dc: 'Contract Name',
    auto_133_f97f507d: 'Previous Contracting Entity Type',
    auto_134_3753c507: 'Contracting Entity Name',
    auto_135_744428fc: 'Reason for Change',
    auto_136_8da52131: 'Company',
    auto_137_2afbac64: 'Enter Contracting Entity Name',
    auto_138_57f014e9: 'Enter Signer Name',
    auto_139_d182fb77: 'Customer',
    auto_140_de3ad287: 'Customer Name',
    auto_141_23569328: 'Referrer',
    auto_142_afe681e4: 'Referrer Name',
    auto_143_0eff35dd: 'Server Error',
    auto_145_6f9d79e2: 'Contracting entity saved successfully',
    auto_146_9d4ad26a: 'Failed to save contracting entity',
    auto_148_fc1ee04e: 'Contract information saved successfully',
    auto_149_3ff4a0bc: 'Failed to save contract information',
    auto_151_b2cb1fca: 'Business License',
    auto_297_3d78ec77: 'Regular Course',
    auto_298_f333a8c9: 'Trial Class',
    auto_299_a8f3aa43: 'Course Name',
    auto_300_4312ad23: 'Subject',
    auto_301_7da2fccf: 'Grade Level',
    auto_302_1b1e015d: 'Curriculum Version',
    auto_303_d7f7b6fe: 'Type',
    auto_304_7e38397a: 'Last Updated',
    auto_305_47aaac0f: 'Grade 1',
    auto_306_0241ea6e: 'Grade 2',
    auto_307_74198474: 'Grade 3',
    auto_308_224610c8: 'Grade 4',
    auto_309_7b55e318: 'Grade 5',
    auto_310_9509e3db: 'Grade 6',
    auto_312_37ee9746: 'Grade 7',
    auto_313_cb06ad6c: 'Grade 8',
    auto_314_e458a0da: 'Grade 9',
    auto_315_fc9c5788: 'Grade 10',
    auto_316_7b2210ea: 'Grade 11',
    auto_317_2e0f0e6d: 'Grade 12',
    auto_318_beb4ebc6: 'Other',
    auto_97_d7b966c9: 'Invoice Type',
    auto_98_30edec66: 'Invoice Amount',
    auto_99_468c6b0e: 'Billing Name',
    auto_100_aa26659d: 'Tax ID',
    auto_101_4decc61e: 'Invoice Date',
    auto_102_eaefd8a1: 'Maximum file size allowed',
    auto_103_8f8acc83: 'Invoice updated successfully',
    auto_104_135f847f: 'Created successfully',
    auto_105_455dce85: 'Failed to update invoice',
    auto_107_ebfbf351: 'Attachments',
    auto_110_c7ff7093: 'Invoice deleted successfully',
    auto_111_e4fb0137: 'Failed to delete invoice',
    auto_177_bc3e76a9: 'Invoice Issued',
    auto_178_12a68c31: 'Add Invoice',
    auto_179_1458572d: 'Upload Invoice',
    auto_69_3fd38855: 'Learning Center created successfully',
    auto_70_9312017b: 'A Learning Center can be generated after submitting contract information',
    auto_71_e4fae474: 'Squirrel Ai Learning Center created successfully',
    auto_72_94662f3c: 'Creation failed',
    auto_74_54000a2d: 'Learning Center basic information saved successfully',
    auto_75_8bc7f4bc: 'Failed to save Learning Center basic information',
    auto_149_f112d9ae: 'Learning Center Basic Information',
    auto_150_ef222d81: 'Not Renovated',
    auto_151_6353753e: 'Under Renovation',
    auto_152_5a2c1f9e: 'Renovation Completed',
    auto_153_1b7ef83a: 'Add Invoice Information',
    auto_154_266681a5: 'Add IP Address',
    auto_155_02a34ead: 'Add Refund Account',
    auto_156_07401cd4: 'Confirm generation of Learning Center ID',
    auto_157_395c1a99: 'Output',
    auto_39_d4d845e5: 'Learning Center Entity',
    auto_40_b5326075: 'Generate Learning Center ID',
    auto_41_f9d88f13: 'Generate Squirrel Ai Contracted Learning Center ID',
    auto_42_27271d63: 'No location detected. Please set location now.',
    auto_47_f4993908: 'Confirm generation of Squirrel Ai Contracted Learning Center ID',
    auto_95_39c76cf4: 'Learning Center entity saved successfully',
    auto_96_200716b1: 'Failed to save Learning Center entity',
    auto_337_b94fcb4a: 'Edit',
    auto_338_86e27584: 'Proof of Payment',
    auto_340_73b27d0e: 'Attachment Details',
    auto_344_33cbbb5c: 'Delete',
    auto_348_71e39444: 'Module',
    auto_349_8314398e: 'Change Timestamp',
    auto_350_0d085309: 'Changed By',
    auto_351_7b267482: 'Change Type',
    auto_352_76d35af0: 'Changed Field',
    auto_84_9632590e: 'Resource created successfully',
    auto_85_f0e3dd3d: 'Failed to create resource',
    auto_86_9d561389: 'Resource deleted successfully',
    auto_87_2d4639f5: 'Failed to delete resource',
    auto_173_3b6b8858: 'Add Resource',
    auto_112_b29a50cc: 'Order ID',
    auto_113_2ed33fd7: 'Enter Order ID',
    auto_115_f405c3c1: 'Customer Name',
    auto_116_663fc5a0: 'Phone Number',
    auto_117_9a88cff8: 'Order Status',
    auto_118_5f2156c7: 'Order Amount',
    auto_119_22bfe9e8: 'Security Deposit',
    auto_120_614faf92: 'Amount Received',
    auto_121_a8918dde: 'Source',
    auto_122_8424df51: 'Please save the contracting entity first',
    auto_123_04c07abd: 'Select related order',
    auto_124_73595a10: 'Order created successfully',
    auto_125_cdc3a9b5: 'Failed to create order',
    auto_196_28920fad: 'Add Related Order',
    auto_280_8bf40c6f: 'All',
    auto_282_7b521f16: 'Active',
    auto_284_9c819402: '1-Star',
    auto_285_9410be07: '2-Star',
    auto_286_4cc3908f: '3-Star',
    auto_287_2550957c: '4-Star',
    auto_288_e37692b0: '5-Star',
    auto_38_180ac681: 'Connected',
    auto_40_5b58412b: 'Agent Name',
    auto_42_8f957442: 'Call Type',
    auto_43_f2bd5c17: 'Caller Number',
    auto_44_d4347792: 'Callee Number',
    auto_45_db33ce18: 'Call Start Time',
    auto_46_c75c29df: 'Call Duration',
    auto_47_587d26e7: 'Call Type',
    auto_48_8c6c4a35: 'Linked Learning Center',
    auto_186_f29dba85: 'Play Recording',
    auto_187_bcbca59e: 'Call Details',
    callRecordView: 'View',
    callRecordCallerNo: 'Caller Number',
    callRecordSeatName: 'Agent Name',
    callRecordDuration: 'Call Duration',
    callRecordEndTime: 'Call End Time',
    callRecordRecording: 'Recording',
    auto_264_67741fc6: 'Refund Account',
    auto_265_4ae61fb3: 'Payout Date',
    auto_271_dbf93436: 'Deleted successfully',
    auto_272_bd6d52ad: 'Delete failed',
    auto_273_f75f0221: 'Edit Refund',
    auto_319_b5c748a3: 'Please select State / City / ZIP Code',
    auto_321_cd47f867: 'State / City / ZIP Code',
    auto_322_15891a67: 'Learning Center Address',
    auto_323_a7e1165c: 'Map Location',
    auto_326_b83f30fc: 'School Level',
    auto_327_e42f2bff: 'Grade',
    auto_188_cac3a089: 'Master Franchisee Information',
    auto_431_23df5e03: 'Standard',
    auto_432_703e94d8: 'Non-standard',
    auto_433_a108eb61: 'Self-service Order',
    auto_434_7ddc00bb: 'New Curriculum Version',
    auto_435_74cfb7b5: 'National Elementary Version',
    auto_240_893162b1: 'Individual',
    auto_241_a237174e: 'Unchanged',
    auto_242_85503de6: 'Updated',
    auto_243_37bf8510: 'Download',
    auto_245_de16923c: 'Contract Amount ($)',
    auto_247_22e2b63a: 'Refund Amount ($)',
    auto_248_590b290c: 'Learning Center After Release',
    auto_169_2c7d8afe: 'Contact Information',
    auto_170_c8cc4c47: 'Add Contact',
    auto_172_491a2d5f: 'Are you sure you want to delete?',
    auto_444_1931dd78: 'Contact saved successfully',
    auto_445_871c454b: 'Failed to save contact',
    auto_194_9e9d1b6f: 'Upload Documents',
    auto_331_64754897: 'Document Type',
    auto_332_cca45631: 'Document Name',
    auto_334_c7ffc3f0: 'Upload Time',
    auto_335_3661a727: 'Uploaded By',
    auto_1_524f619a: 'Publish',
    auto_2_0df5a83d: 'Unpublish',
    auto_3_731368ac: 'Login Page Floating Banner',
    auto_4_262a7a65: 'Fullscreen Pop-up',
    auto_190_813ee734: 'Learning Center Equipment Information',
    auto_461_b5d06640: 'Equipment information saved successfully',
    auto_462_f02bd24c: 'Failed to save equipment information',
    auto_192_56f8e083: 'Curriculum Version Information',
    auto_456_62d92b1b: 'Curriculum version information saved',
    auto_440_07489eb9: 'Mini Program Home',
    auto_441_2ca7ae28: 'Mini Program Squirrel Cup',
    auto_451_3cde6d96: 'File',
    auto_452_bca81947: 'Download failed',
    auto_446_3a5e69f5: 'Public School',
    auto_447_4f0ebfbd: 'Private School',
    auto_448_7d07537e: 'International School',
    auto_458_ce7a7f2d: 'Idle',
    auto_459_43bd0c5e: 'Busy',
    auto_449_8e4ae13d: 'Activated',
    auto_450_e46607fd: 'Not Activated',
    auto_197_950038b1: 'Back',
    auto_198_945e0f9a: 'Clear',
    orgSupport: 'Support Staff',
    orgCampusDetailAddress: 'Learning Center Address',
    orgSupportHandoverTime: 'Support Handover Time',
    orgPlannedOpeningTime: 'Planned Opening Date',
    orgActualOpeningTime: 'Actual Opening Date',
    orgCampusAccountStatus: 'Learning Center Account Status',
    orgReason: 'Reason',
    orgChargePlan: 'Pricing Plan',
    orgFreePeriod: 'Fee Waiver Period',
    orgPricingCoefficient: 'Pricing Coefficient',
    orgOnlineOfflineLinkageStatus: 'Online–Offline Integration Status',
    orgHeadOfficeOnlinePayment: 'Head Office Online Payment',
    orgAutoRechargeDeductionRatio: 'Auto-Recharge Deduction Rate',
    orgMerchant: 'Merchant',
    orgMerchantNo: 'Merchant ID',
    orgDailyClaimLimit: 'Daily Claim Limit',
    orgDailyPhoneViewLimit: 'Daily Phone View Limit',
    orgPrimaryPricing: 'Elementary School Pricing',
    orgJuniorPricing: 'Middle School Pricing',
    orgHighPricing: 'High School Pricing',
    orgPrimaryOriginalPricing: 'Elementary Original Pricing',
    orgJuniorOriginalPricing: 'Middle School Original Pricing',
    orgHighOriginalPricing: 'High School Original Pricing',
    orgPerClassHour: 'Per Class Hour',
    orgFrontDeskPhone: 'Front Desk Phone',
    orgCampusArea: 'Learning Center Area',
    orgSquareMeter: 'sq ft',
    orgClassroomCount: 'Number of Classrooms',
    orgMaxCapacity: 'Maximum Capacity',
    orgUnitPiece: 'units',
    orgUnitPeople: 'people',
    orgAnnualRent: 'Annual Rent',
    orgMonthlyRent: 'Monthly Rent',
    orgDecorationStatus: 'Renovation Status',
    orgDecorationTime: 'Renovation Date',
    orgConsignee: 'Recipient',
    orgConsigneeContact: 'Recipient Contact',
    orgShippingAddress: 'Shipping Address',
    orgTaxpayerId: 'Tax ID',
    orgAddress: 'Address',
    orgPhone: 'Phone Number',
    orgBank: 'Bank Name',
    orgBankAccount: 'Bank Account Number',
    orgComputer: 'Computer',
    orgPhoneDevice: 'Phone Device',
    orgIdCardPunch: 'ID Card Scanner',
    orgWritingTablet: 'Writing Tablet',
    text09i2: 'Admissions Phone:',
    text0cti: 'Maximum Capacity:',
    text1ewz: 'Actions',
    text1r1i: 'Payment Status:',
    text1trb: 'Equity Amount:',
    text20hu: 'View',
    text2vrw: 'Preparation Period:',
    text3hl2: 'Export Contract',
    text3i71: 'Site Selection Staff:',
    text3lej: 'Equity Conversion:',
    text3pv0: 'Contract Attachments',
    text3qfo: 'Invoice Title:',
    text400w: 'Payout Installment:',
    text4qds: 'Address:',
    text4r3a: 'Email:',
    text57ze: 'Merchant:',
    text5ckl: 'Contact Information:',
    text5nzv: 'Refund Installment:',
    text73j3: 'Reason:',
    text79cm: 'Multi-Center Search',
    text7ghw: 'Pricing Coefficient:',
    text7o9x: 'Bank Name:',
    text8egi: 'Franchise Region Name:',
    text8f1k: 'Change Details',
    text9onf: 'Contact Name:',
    text9tck: 'Support Staff:',
    textb0ke: 'Order Information',
    textb1gv: 'Writing Tablet:',
    textb2a3: 'Actual Refund Amount:',
    textbccd: 'Region Release',
    textbg1j: 'Organization Information',
    textbs5c: 'Refund Reason:',
    textdy3e: 'Amount Received:',
    texte7q0: 'Organization Tag:',
    texteb59: 'Bank Name:',
    textf5ni: 'Security Deposit:',
    textf5wl: 'Pricing Status:',
    textfhfp: 'Organization Type:',
    textfpkt: 'Attachment:',
    textgdcv: 'Invoice Information',
    textgk5w: 'Other Signed Documents',
    textgq47: 'Refund Method:',
    textgw9t: 'Auto-Recharge Deduction Rate:',
    texthi1b: 'Contact Address:',
    texthuk5: 'Contract Status:',
    texti3gp: 'Learning Center Area:',
    textiawl: 'Total Refund Amount:',
    textitua: 'Enable Large Group Classes',
    textj8iv: 'Contract Amount:',
    textkcim: 'Release Status:',
    textkl00: 'Location:',
    textkw0m: 'Organization Rating:',
    textkwte: 'Refund Information',
    textkxu2: 'Organization Type (School):',
    textln8s: 'Number of Classrooms:',
    textm843: 'Phone Number:',
    textmbem: 'Contract Entity Change Status:',
    textmiqa: 'Multi-Center:',
    textnevv: 'Signing Manager:',
    textnfdt: 'Camera:',
    textng46: 'Account Type:',
    textngln: 'Contact Information',
    textoe85: 'Organization Name:',
    textp4vn: 'Discounted Contract:',
    textptcu: 'Opening Status:',
    textpwah: 'Admissions Email:',
    textq675: 'Learning Center Equipment Information',
    textql7m: 'Recipient:',
    textqsri: 'Fee Waiver Period:',
    textr4ty: 'Enable Small Group Classes',
    textrpyp: 'Head Office Online Payment:',
    texts3x4: 'Curriculum Version Information',
    textshon: 'Full Name:',
    textsnnc: 'Learning Center Address:',
    textt9pg: 'Pricing Plan:',
    texttesz: 'Contracting Entity:',
    textthsl: 'Organization Entity',
    texttl4e: 'Regional Standard:',
    texttnu6: 'Contact Phone:',
    texttvx2: 'Learning Center Tag:',
    textu21u: 'Legal Representative Name:',
    textu2w0: 'Payout Status:',
    textu8yx: 'Computer:',
    textuag3: 'Payout Information',
    textug2a: 'Shipping Address:',
    textuwlj: 'Regional Standard Description:',
    textvj4l: 'Post-Release Learning Center Information',
    textvmez: 'Business License Attachment:',
    textvz77: 'Marketing Subsidy:',
    textwfvm: 'Document Information',
    textwkrh: 'Organization Basic Information',
    textwr4i: 'Deduction Amount:',
    textxgbj: 'Handover Status:',
    textxquz: 'Phone Device:',
    textye7k: 'Pricing & System Information',
    textyu3h: 'Recipient Contact:',
    textzgvh: 'Select Coordinates',
    textzp3y: 'Renovation Status:',
    orgCamera: 'Camera',
    smallsmall: 'Elementary Small Group Original Pricing:',
    smallmiddle: 'Middle School Small Group Original Pricing:',
    smallhighmiddle: 'High School Small Group Original Pricing:',
    bigsmall: 'Elementary Large Group Pricing:',
    bigmiddle: 'Middle School Large Group Pricing:',
    bighighmiddle: 'High School Large Group Pricing:',
    yihour: 'First Payout Date:',
    er: 'Second Payout Amount:',
    yi: 'First Payout Amount:',
    erhour: 'Second Payout Date:',
    backhour: 'Last Payment Date:',
    backyihour: 'Final Payout Date:',
    backyi: 'Final Payout Amount:',
    textContractPeriod: 'Contract Term:',
    textSignTime: 'Signing Date:',
    textGiveDeduct: 'Promotional Credit:',
    textAccountDeductAmt: 'Account Deduction Amount:',
    textBizLicenseNo: 'Business License Number:',
    textIdCardNo: 'ID Number:',
    textTermAgreementTime: 'Termination Agreement Date:',
    textTermAgreementEntryTime: 'Termination Agreement Posting Date:',
  },
};
